export const environment = {
  production: true,
  envName: 'production',
  appName: 'OECD.AI Admin Dashboard',
  baseUrl: 'https://portal.oecdai.org',
  apiBaseUrl: '/api',
  storagePath: '/api/storage',
  tokenName: 'oecdAIToken',
  tokenAllowedDomains: ['/api'],
  enableBugsnag: true,
  bugsnagApiKey: '3ae219dee6c5f9a8caa637bd10f3a6b1',
  isOnboarding: false,
  policyInitiativePath: 'https://oecd.ai/en/dashboards/policy-initiatives/',
  keycloakEnabled: true,
  keycloakUrl: 'https://auth.oecdai.org/',
  keycloakRealm: 'oecdai',
  keycloakClientId: 'prod-oecd-ai-case-api',
  keycloakRefreshLoginMs: 10 * 60 * 1000 // 10 minutes
}
